import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { acknowledgeAllReleaseNotes, type ReleaseNote } from 'store/entities/release-notes/release-notes';
import { acknowledgeReleaseNotesLocally } from 'views/navigation/new-app-version/release-notes-storage';
import type { TAppDispatch, TRootState } from 'src/store/store-types';
import { LatestUpdatesModal } from './latest-updates-modal';

export const ReleaseNotesVersionModal = () => {
  const dispatch = useDispatch<TAppDispatch>();
  const unseenNotes = useSelector((state: TRootState): ReleaseNote[] => state.entities.releaseNotes?.unseenNotes ?? []);

  useEffect(() => {
    /*
      Disable replay once the release notes modal has been triggered.
      Otherwise if a user leaves their browser window open for hours,
      the Sentry replay plugin can crash (Maximum call stack size exceeded).
     */
    Sentry.getReplay()?.stop();
  }, []);

  const handleLatestUpdatesClose = () => {
    const releaseIds = unseenNotes.map((note) => note.id);
    // Local ack first (synchronous) - the safety net that prevents the modal
    // from reappearing even if the backend ack fails.
    acknowledgeReleaseNotesLocally(releaseIds);
    // Best-effort backend ack; any request cut off by the reload is retried on
    // the next launch via syncLocalAckWithServer.
    try {
      dispatch(acknowledgeAllReleaseNotes(releaseIds));
    } catch {
      // ignored - localStorage record is authoritative
    }
    window.location.reload();
  };

  return <LatestUpdatesModal onClose={handleLatestUpdatesClose} releaseNotes={unseenNotes} />;
};
